module.exports = __webpack_public_path__ + "img/yiduiyi06.5bb96b7c.jpg";